import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function LoginScreen({ onLogin }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const creds = { username, password };
      await axios.post(`${API}/admin/login`, {}, { auth: creds });
      sessionStorage.setItem('adminCreds', JSON.stringify(creds));
      onLogin(creds);
      toast.success('Login successful');
    } catch (err) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-[#01195d]">Admin Login</h1>
          <p className="text-slate-600 mt-2">GS Pacific Management</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label>Username</Label>
            <Input 
              data-testid="admin-username-input"
              value={username} 
              onChange={e => setUsername(e.target.value)} 
              className="mt-1" 
              required 
            />
          </div>
          <div>
            <Label>Password</Label>
            <Input 
              data-testid="admin-password-input"
              type="password" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              className="mt-1" 
              required 
            />
          </div>
          <Button data-testid="admin-login-button" type="submit" disabled={loading} className="w-full bg-[#01195d] h-12">
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>
        <div className="mt-6 text-center">
          <button onClick={() => navigate('/')} className="text-sm text-slate-500 hover:text-[#01195d]">
            ← Back to website
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
